import psyImages from "../../components/utility/psychologicalImageImports";

const artChoicesBg = [
  {
    label: "Минималистични дизайни.",
    value:
      'минималистични дизайни с неутрално сиво и дълбоко, контрастиращо черно.{"Gray":"3","Black":"2"}',
    imageUrl: psyImages["art/forFormA.jpg"],
  },
  {
    label: "Динамично и смело абстрактно изкуство.",
    value:
      'Динамично и смело абстрактно изкуство със зашеметяващи червени и весели жълти тонове.{"Red":"3","Yellow":"2"}',
    imageUrl: psyImages["art/forFormB.jpg"],
  },

  {
    label: "Спокойни пейзажни картини.",
    value:
      'Спокойни пейзажни картини с много сини небеса, вода и лилави залези.{"Blue":"3","Violet":"2"}',
    imageUrl: psyImages["art/forFormC.jpg"],
  },

  {
    label: "Смели, геометрични мотиви.",
    value:
      'Смели, геометрични мотиви със стабилни зелени и кафяви тонове.{"Green":"3","Brown":"2"}',
    imageUrl: psyImages["art/forFormD.jpg"],
  },
];

export default artChoicesBg;
